import { render } from "./CompCalenderPicker.vue?vue&type=template&id=506abfea&scoped=true"
import script from "./CompCalenderPicker.vue?vue&type=script&lang=js"
export * from "./CompCalenderPicker.vue?vue&type=script&lang=js"

import "./CompCalenderPicker.vue?vue&type=style&index=0&id=506abfea&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506abfea"]])

export default __exports__